module.exports = {"title":"1917. Столетие ужаса","description":"Октябрьская революция — одно из крупнейших политических событий XX века, произошедшее в России в октябре (по новому стилю — в ноябре) 1917 года и повлиявшее на дальнейший ход всемирной истории","image":"https://revolution.lenta.ru/img/share.jpg","url":"https://revolution.lenta.ru/","fbappid":1957035941204155,"trackingID":"UA-105301080-21","clientTrackingID":"UA-78538268-25","top100":4513258,"clientTop100":0,"yaMetrika":27714477}


//////////////////
// WEBPACK FOOTER
// ./js/meta.json
// module id = 7
// module chunks = 0